var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.3548 11.8546L5.06893 6.99347L0.3548 2.13239C0.242314 2.01639 0.153087 1.87869 0.0922102 1.72714C0.0313336 1.57559 1.18523e-09 1.41316 0 1.24912C-1.18522e-09 1.08509 0.0313336 0.922655 0.0922102 0.771104C0.153087 0.619554 0.242314 0.48185 0.3548 0.365858C0.467285 0.249866 0.600824 0.157858 0.747794 0.0950842C0.894763 0.0323095 1.05228 0 1.21136 0C1.37044 9.53674e-07 1.52796 0.0323095 1.67493 0.0950842C1.8219 0.157858 1.95544 0.249866 2.06792 0.365858L7.64469 6.11647C7.75732 6.23238 7.84668 6.37005 7.90765 6.52161C7.96862 6.67318 8 6.83565 8 6.99973C8 7.16382 7.96862 7.32629 7.90765 7.47785C7.84668 7.62942 7.75732 7.76709 7.64469 7.883L2.06792 13.6336C1.95552 13.7498 1.82201 13.8419 1.67503 13.9048C1.52805 13.9676 1.37049 14 1.21136 14C1.05224 14 0.894675 13.9676 0.747695 13.9048C0.600715 13.8419 0.467202 13.7498 0.3548 13.6336C-0.106893 13.145 -0.119043 12.3432 0.3548 11.8546Z",
    fill: "#0B1836"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrowBlack);
export default __webpack_public_path__ + "static/media/next-arrow-black.8cf41a57b3d11b7f47bc91c434696e66.svg";
export { ForwardRef as ReactComponent };